<template>
  <div>
    <section role="main" class="empty">
      <div class="container">
        <div class="row icon-tabs">
          <ul class="nav nav-tabs" role="tablist">
            <li class="nav-item">
              <router-link to="/executive" class="nav-link"
                ><img src="/img/icons/executives.png" alt="Executives" />
                Executives</router-link
              >
            </li>
            <li class="nav-item">
              <router-link to="/company" class="nav-link"
                ><img src="/img/icons/companies.png" alt="Companies" />
                Companies</router-link
              >
            </li>
            <li class="nav-item">
              <router-link to="/news" class="nav-link"
                ><img src="/img/icons/deals.png" alt="News" /> News</router-link
              >
            </li>
            <li class="nav-item">
              <router-link to="/deals-transactions" class="nav-link active"
                ><img src="/img/icons/deals.png" alt="Deals & Transactions" />
                Deals & Transactions</router-link
              >
            </li>
            <li class="nav-item">
              <router-link to="/listing" class="nav-link"
                ><img src="/img/book.png" style="height: 23px" />
                Listing</router-link
              >
            </li>
            <!-- <li class="nav-item">
              <router-link to="/commentaries" class="nav-link"
                ><img src="/img/icons/commentaries.png" alt="Commentaries" />
                Commentaries</router-link
              >
            </li> -->
            <li class="nav-item">
              <router-link to="/interesting-bites" class="nav-link"
                ><img
                  src="/img/icons/interesting.png"
                  alt="Interesting Facts"
                />
                Interesting Facts</router-link
              >
            </li>
            <!-- NOTE: Temporary hide the open position tab. -->
            <!-- <li class="nav-item">
              <router-link to="/open-positons-new" class="nav-link"
                ><img src="/img/icons/position.png" alt="Open Position" /> Open
                Positons</router-link
              >
            </li> -->
            <li class="">
              <a
                class="nav-link"
                style="
                  font-weight: bold !important;
                  margin-top: 8px;
                  font-size: 13px;
                  color: #1f3342;
                  margin-left: 290px;
                "
              >
                {{ count }}</a
              >
            </li>
          </ul>
          <div id="fourthmenu" class="tab-content mb-3">
            <div class="container px-0">
              <div class="row">
                <div class="col-lg-8 col-sm-8">
                  <!-- <form class="form-search form-inline"> -->
                  <input
                    type="text"
                    class="search-query"
                    style="border: 0px none; width: 100%"
                    v-on:keyup.enter="getList(0)"
                    placeholder="Search"
                    v-model="searchObj.keyword"
                  />
                  <!-- </form> -->
                </div>
                <div class="col-lg-4 col-sm-4 col-6 text-right deals-offcanvas">
                  <button class="menuButton" id="openOffcanvas" v-on:click="openCloseModel()">
                    <div class="filter-title-name">Build My Search</div>
                  </button>
                </div>
              </div>
              <hr class="mt-0 mb-2" />
            </div>
            <div v-if="showDidYouMean" class="did-you-mean">
              Did you mean: <span class="did-you-mean-prompt">{{ searchedPrompt }}</span>
            </div>
            <!-- <hr /> -->
            <div v-for="(data, index) in list" :key="index">
              <div class="row mt-4">
                <div
                  class="col-lg-2 col-sm-2 text-center"
                  style="cursor: pointer"
                  v-on:click="
                    $router.push(
                      '/company-detail/' + data.primary_company.company_id
                    )
                  "
                >
                  <a>
                    <img
                      :title="
                        data.primary_company &&
                        data.primary_company.company_name
                          ? data.primary_company.company_name
                          : ''
                      "
                      :src="
                        data.primary_company &&
                        data.primary_company.company_logo
                          ? data.primary_company.company_logo
                          : '/img/user-pic.png'
                      "
                      alt=""
                      width="40"
                      height="40"
                    />
                  </a>
                  <br />
                  <a>
                    <!-- the primary company's current country, the deal's own as fallback -->
                    <!-- OldCode:- :country="data.country ? data.country.country_code : 'US'" -->
                    <country-flag
                      :country="
                        data.primary_company && data.primary_company.company_country
                          ? data.primary_company.company_country.country_code
                          : data.country
                          ? data.country.country_code
                          : 'US'
                      "
                    />
                  </a>
                  <br />
                  <span class="update-date"
                    >Published Date :
                    {{
                      $helperService.getFormatedDate(data.published_date)
                    }}</span
                  >
                </div>
                <div class="col-lg-8 col-sm-5 pb-3 txt-center">
                  <p class="clrb" style="padding: 0; margin: 0">
                    {{ data.headline }}
                  </p>
                  <div class="col-12 row">
                    <div class="col-3 mt-3 row">
                      <div
                        v-for="(data2, index2) in data.deals_mention_executives"
                        :key="index2"
                      >
                        <div v-if="index2 <= 4">
                          <img
                            v-if="
                              data2.gender == 'female' && !data2.executive_logo
                            "
                            style="
                              cursor: pointer;
                              border: 1px solid white; /*! padding: 0.1px; */
                              box-shadow: 18px;
                              box-shadow: 0px 0px 0.5px 0.5px GREY;
                            "
                            :title="data2.executive_name"
                            v-on:click="
                              $router.push(
                                '/executive-detail/' + data2.executives_id
                              )
                            "
                            :src="
                              data2.executive_logo
                                ? data2.executive_logo
                                : '/img/female.png'
                            "
                            width="50"
                            height="50"
                            :class="index2 == 0 ? 'sm-img' : 'sm-img minus8'"
                            :style="
                              index2 == 0 ? 'width: 31px;' : 'width: 37px;'
                            "
                          />
                          <img
                            v-if="
                              data2.gender == 'male' && !data2.executive_logo
                            "
                            style="
                              cursor: pointer;
                              border: 1px solid white; /*! padding: 0.1px; */
                              box-shadow: 18px;
                              box-shadow: 0px 0px 0.5px 0.5px GREY;
                            "
                            :title="data2.executive_name"
                            v-on:click="
                              $router.push(
                                '/executive-detail/' + data2.executives_id
                              )
                            "
                            :src="
                              data2.executive_logo
                                ? data2.executive_logo
                                : '/img/male.png'
                            "
                            width="50"
                            height="50"
                            :class="index2 == 0 ? 'sm-img' : 'sm-img minus8'"
                            :style="
                              index2 == 0 ? 'width: 31px;' : 'width: 37px;'
                            "
                          />
                          <img
                            v-if="data2.executive_logo || !data2.gender"
                            style="
                              cursor: pointer;
                              border: 1px solid white; /*! padding: 0.1px; */
                              box-shadow: 18px;
                              box-shadow: 0px 0px 0.5px 0.5px GREY;
                            "
                            :title="data2.executive_name"
                            v-on:click="
                              $router.push(
                                '/executive-detail/' + data2.executives_id
                              )
                            "
                            :src="
                              data2.executive_logo
                                ? data2.executive_logo
                                : '/img/male.png'
                            "
                            width="50"
                            height="50"
                            :class="index2 == 0 ? 'sm-img' : 'sm-img minus8'"
                            :style="
                              index2 == 0 ? 'width: 31px;' : 'width: 37px;'
                            "
                          />
                        </div>
                      </div>
                      <!-- sm-img minus8 -->
                    </div>
                    <div class="col-3 mt-3 row">
                      <div
                        v-for="(data2, index2) in data.deals_mention_company"
                        :key="index2"
                      >
                        <div v-if="index2 <= 4">
                          <img
                            style="
                              cursor: pointer;
                              border: 1px solid white; /*! padding: 0.1px; */
                              box-shadow: 18px;
                              box-shadow: 0px 0px 0.5px 0.5px GREY;
                            "
                            :title="data2.company_name"
                            v-on:click="
                              $router.push(
                                '/company-detail/' + data2.company_id
                              )
                            "
                            :src="data2.company_logo"
                            width="50"
                            height="50"
                            :class="index2 == 0 ? 'sm-img' : 'sm-img minus8'"
                            :style="
                              index2 == 0 ? 'width: 31px;' : 'width: 37px;'
                            "
                          />
                        </div>
                      </div>
                      <!-- sm-img minus8 -->
                    </div>
                    <div class="col-3 mt-3 row">
                      <div
                        v-for="(
                          data2, index2
                        ) in data.deals_invested_executives"
                        :key="index2"
                      >
                        <div v-if="index2 <= 4">
                          <img
                            v-if="
                              data2.gender == 'female' && !data2.executive_logo
                            "
                            style="
                              cursor: pointer;
                              border: 1px solid white; /*! padding: 0.1px; */
                              box-shadow: 18px;
                              box-shadow: 0px 0px 0.5px 0.5px GREY;
                            "
                            :title="data2.executive_name"
                            v-on:click="
                              $router.push(
                                '/executive-detail/' + data2.executives_id
                              )
                            "
                            :src="
                              data2.executive_logo
                                ? data2.executive_logo
                                : '/img/female.png'
                            "
                            width="50"
                            height="50"
                            :class="index2 == 0 ? 'sm-img' : 'sm-img minus8'"
                            :style="
                              index2 == 0 ? 'width: 31px;' : 'width: 37px;'
                            "
                          />
                          <img
                            v-if="
                              data2.gender == 'male' && !data2.executive_logo
                            "
                            style="
                              cursor: pointer;
                              border: 1px solid white; /*! padding: 0.1px; */
                              box-shadow: 18px;
                              box-shadow: 0px 0px 0.5px 0.5px GREY;
                            "
                            :title="data2.executive_name"
                            v-on:click="
                              $router.push(
                                '/executive-detail/' + data2.executives_id
                              )
                            "
                            :src="
                              data2.executive_logo
                                ? data2.executive_logo
                                : '/img/male.png'
                            "
                            width="50"
                            height="50"
                            :class="index2 == 0 ? 'sm-img' : 'sm-img minus8'"
                            :style="
                              index2 == 0 ? 'width: 31px;' : 'width: 37px;'
                            "
                          />
                          <img
                            v-if="data2.executive_logo || !data2.gender"
                            style="
                              cursor: pointer;
                              border: 1px solid white; /*! padding: 0.1px; */
                              box-shadow: 18px;
                              box-shadow: 0px 0px 0.5px 0.5px GREY;
                            "
                            :title="data2.executive_name"
                            v-on:click="
                              $router.push(
                                '/executive-detail/' + data2.executives_id
                              )
                            "
                            :src="
                              data2.executive_logo
                                ? data2.executive_logo
                                : '/img/male.png'
                            "
                            width="50"
                            height="50"
                            :class="index2 == 0 ? 'sm-img' : 'sm-img minus8'"
                            :style="
                              index2 == 0 ? 'width: 31px;' : 'width: 37px;'
                            "
                          />
                        </div>
                      </div>
                      <!-- sm-img minus8 -->
                    </div>
                    <div class="col-3 mt-3 row">
                      <div
                        v-for="(data2, index2) in data.deals_invested_company"
                        :key="index2"
                      >
                        <div v-if="index2 <= 4">
                          <img
                            style="
                              cursor: pointer;
                              border: 1px solid white; /*! padding: 0.1px; */
                              box-shadow: 18px;
                              box-shadow: 0px 0px 0.5px 0.5px GREY;
                            "
                            :title="data2.company_name"
                            v-on:click="
                              $router.push(
                                '/company-detail/' + data2.company_id
                              )
                            "
                            :src="data2.company_logo"
                            width="50"
                            height="50"
                            :class="index2 == 0 ? 'sm-img ' : 'sm-img minus8'"
                            :style="
                              index2 == 0 ? 'width: 31px;' : 'width: 37px;'
                            "
                          />
                        </div>
                      </div>
                      <!-- sm-img minus8 -->
                    </div>
                  </div>

                  <!-- Company tags: tags, type, size, stage -->
                  <div
                    class="news-tags"
                    v-if="data.company_tags && data.company_tags.length"
                  >
                    <span class="news-tags-label calibri">Company Tags</span>
                    <span
                      class="news-tag news-tag-company"
                      v-for="(tag, tagIndex) in data.company_tags"
                      :key="'com-tag-' + tagIndex"
                      >{{ tag }}</span
                    >
                  </div>
                </div>

                <div
                  v-if="data.is_company_logo == 0"
                  v-on:click="openLink(data.news_url)"
                  style="cursor: pointer"
                  class="col-lg-1 col-sm-2 col-6 text-center"
                >
                  <img
                    :title="
                      data.publication && data.publication.name
                        ? data.publication.name
                        : ''
                    "
                    :src="
                      data.publication && data.publication.publication_logo
                        ? data.publication.publication_logo
                        : ''
                    "
                    height="60"
                    width="150"
                  />
                </div>
                <div
                  v-if="data.is_company_logo == 1"
                  v-on:click="openLink(data.news_url)"
                  style="cursor: pointer"
                  class="col-lg-1 col-sm-2 col-6 text-center"
                >
                  <img
                    :title="
                      data.primary_company && data.primary_company.company_name
                        ? data.primary_company.company_name
                        : ''
                    "
                    :src="
                      data.primary_company && data.primary_company.company_logo
                        ? data.primary_company.company_logo
                        : '/img/user-pic.png'
                    "
                    height="60"
                    width="150"
                  />
                </div>
              </div>
              <hr />
            </div>
            <div class="row mx-0 mb-4">
              <div class="col-lg-12 mt-5 text-center">
                <div class="page-bottom-pagination text-right">
                  <Pagination
                    @page-change="pageChange"
                    @items-per-page-change="itemsPerPageChange"
                    ref="listPagination"
                  />
                </div>
              </div>
            </div>
            <ErrorComponent @retry="getList(0)" ref="errorComponent" />
          </div>
        </div>
      </div>
    </section>
  </div>

  <!--- Deal & transaction Section Filter View start here-->
  <div class="navbar news-offcanvas">
    <div
      :class="
        isOpenModel
          ? 'navbar-collapse offcanvas-collapse open'
          : 'navbar-collapse offcanvas-collapse close'
      "
    >
      <div class="inner-filter-close">
        <div class="row">
          <div class="col-lg-6 col-sm-6 col-6 text-left">
            <h6
              class="mb-0"
              style="font-size: 15px; padding-top: 2px; color: #de4a38"
            >
              Deals & Transactions
            </h6>
          </div>
          <div class="col-lg-6 col-sm-6 col-6" id="closeOffcanvas">
            <button
              class="navbar-toggler menuButton"
              v-on:click="openCloseModel()"
            >
              <img src="/img/cross.png" width="22" height="22" />
            </button>
          </div>
        </div>
      </div>
      <div class="form-group mb-3 px-3" v-if="selectedFilters.length">
        <div class="selected-filters d-flex flex-wrap mt-2">
          <span
            v-for="(filter, index) in selectedFilters"
            :key="index"
            class="selected-chip"
            style="cursor: pointer"
            @click="removeSelectedFilter(filter)"
          >
            {{ filter.name }} <span style="margin-left: 5px">&times;</span>
          </span>
        </div>
      </div>
      <div class="inner-data">
        <div class="filter-modal">
          <div class="overflowScroll">
            <div id="accordion" class="accordion">
              <div class="card mb-0">
                <!-- current company --->
                <div
                  class="card-header collapsed px-1"
                  data-toggle="collapse"
                  data-parent="#accordion"
                  href="#collapseOne"
                >
                  <a class="card-title"> Current Company </a>
                </div>
                <div id="collapseOne" class="card-body collapse show">
                  <div class="form-group mb-3">
                    <!-- <label class="mb-1" style="font-weight: normal">Search Company</label> -->
                    <!-- <Multiselect mode="tags" trackBy="company_name" label="company_name" valueProp="id"
                    closeOnSelect="true" placeholder="Select" v-model="searchObj.new_company_ids" :options="companyList"
                    :noOptionsText="'Enter Text'" searchable="true" @search-change="searchCompanyName($event)"
                    @input="inputCurrentCompany($event)" /> -->
                    <multiselect
                      v-model="searchObj.company_ids"
                      :options="companyList"
                      :multiple="true"
                      placeholder="Select"
                      label="company_name"
                      track-by="company_name"
                      value-prop="id"
                      searchable="true"
                      mode="tags"
                      @search-change="searchCompanyName($event)"
                      @input="onCompanyChange"
                      :show-labels="false"
                    >
                    </multiselect>
                  </div>
                </div>
                <!-- Industry -->
                <div
                  class="card-header collapsed px-1"
                  data-toggle="collapse"
                  data-parent="#accordion"
                  href="#collapseTwo"
                >
                  <a class="card-title"> Industry </a>
                </div>
                <div id="collapseTwo" class="card-body collapse show">
                  <form>
                    <div class="d-flex flex-wrap gap-2">
                      <label
                        v-for="(industry, index) in getDisplayedIndustries()"
                        :key="index"
                        class="btns btn-block"
                        :class="{
                          'btn-danger': searchObj.industry_ids.includes(
                            industry.id
                          ),
                          'btn-success active':
                            !searchObj.industry_ids.includes(industry.id),
                        }"
                      >
                        <input
                          type="checkbox"
                          class="d-none"
                          :name="industry.industry_name"
                          :value="industry.id"
                          v-model="searchObj.industry_ids"
                          autocomplete="off"
                          @change="
                            handleToggle(
                              industry.id,
                              'industry',
                              industry.industry_name
                            )
                          "
                        />
                        {{ industry.industry_name }}
                      </label>
                    </div>
                    <!-- View more Button -->
                    <div class="mt-2 text-right">
                      <span v-if="!showAllIndustries" 
                        @click="handleShowMore"
                        style="cursor: pointer; 
                        font-size: 14px; 
                        color: black; 
                        font-weight: 500;">
                        view more
                      </span>
                    </div>                    
                  </form>
                </div>
                <!--sub sector -->
                <div
                  v-if="isShowSubsector"
                  class="card-header collapsed px-1"
                  data-toggle="collapse"
                  data-parent="#accordion"
                  href="#collapseThree"
                >
                  <a class="card-title"> Sub Sector </a>
                </div>
                <div id="collapseThree" class="card-body collapse show">
                  <form>
                    <div class="d-flex flex-wrap gap-2">
                      <label
                        v-for="(subsector, index) in subsectorList"
                        :key="index"
                        class="btns btn-block"
                        :class="{
                          'btn-danger': searchObj.subsector_ids.includes(
                            subsector.id
                          ),
                          'btn-success active':
                            !searchObj.subsector_ids.includes(subsector.id),
                        }"
                      >
                        <input
                          type="checkbox"
                          class="d-none"
                          :name="subsector.industry_name"
                          :value="subsector.id"
                          v-model="searchObj.subsector_ids"
                          autocomplete="off"
                          @change="
                            handleToggle(
                              subsector.id,
                              'subsector',
                              subsector.industry_name
                            )
                          "
                        />
                        {{ subsector.industry_name}}
                      </label>
                    </div>
                  </form>
                </div>
                <!-- Deal Type -->
                <div
                  class="card-header collapsed px-1"
                  data-toggle="collapse"
                  data-parent="#accordion"
                  href="#collapseThree"
                >
                  <a class="card-title"> Deal Type </a>
                </div>
                <div id="collapseThree" class="card-body collapse show">
                  <form>
                    <div class="d-flex flex-wrap gap-2">
                      <label
                        v-for="(dealType, index) in topicList"
                        :key="index"
                        class="btns btn-block"
                        :class="{
                          'btn-danger': searchObj.topic_ids.includes(
                            dealType.id
                          ),
                          'btn-success active': !searchObj.topic_ids.includes(
                            dealType.id
                          ),
                        }"
                      >
                        <input
                          type="checkbox"
                          class="d-none"
                          :name="dealType.topic_name"
                          :value="dealType.id"
                          v-model="searchObj.topic_ids"
                          autocomplete="off"
                          @change="
                            handleToggle(
                              dealType.id,
                              'deal_type',
                              dealType.topic_name
                            )
                          "
                        />
                        {{ dealType.topic_name }}
                      </label>
                    </div>
                  </form>
                </div>
                <!-- Deal Stage -->
                <div
                  class="card-header collapsed px-1"
                  data-toggle="collapse"
                  data-parent="#accordion"
                  href="#collapseFour"
                >
                  <a class="card-title"> Deal Stage </a>
                </div>
                <div
                  id="collapseFour"
                  class="card-body collapse show"
                  data-parent="#accordion"
                >
                  <form>
                    <div class="d-flex flex-wrap gap-2">
                      <label
                        v-for="(dealStage, index) in dealStageList"
                        :key="index"
                        class="btns btn-block"
                        :class="{
                          'btn-danger': searchObj.deal_stage_ids.includes(
                            dealStage.id
                          ),
                          'btn-success active':
                            !searchObj.deal_stage_ids.includes(dealStage.id),
                        }"
                      >
                        <input
                          type="checkbox"
                          class="d-none"
                          :name="dealStage.name"
                          :value="dealStage.id"
                          v-model="searchObj.deal_stage_ids"
                          autocomplete="off"
                          @change="
                            handleToggle(
                              dealStage.id,
                              'deal_stage',
                              dealStage.name
                            )
                          "
                        />
                        {{ dealStage.name }}
                      </label>
                    </div>
                  </form>
                </div>
                <!-- Company Type -->
                <div
                  class="card-header collapsed px-1"
                  data-toggle="collapse"
                  data-parent="#accordion"
                  href="#collapseFive"
                >
                  <a class="card-title"> Company Type </a>
                </div>
                <div id="collapseFive" class="card-body collapse show">
                  <form>
                    <div class="d-flex flex-wrap gap-2">
                      <label
                        v-for="(comapnyType, index) in company_types"
                        :key="index"
                        class="btns btn-block"
                        :class="{
                          'btn-danger':
                            searchObj.company_types.includes(comapnyType),
                          'btn-success active':
                            !searchObj.company_types.includes(comapnyType),
                        }"
                      >
                        <input
                          type="checkbox"
                          class="d-none"
                          :name="comapnyType"
                          :value="comapnyType"
                          v-model="searchObj.company_types"
                          autocomplete="off"
                          @change="
                            handleToggle(
                              comapnyType,
                              'company_type',
                              comapnyType
                            )
                          "
                        />
                        {{ comapnyType }}
                      </label>
                    </div>
                  </form>
                </div>
                <!-- Tags (of the deal company) -->
                <div
                  class="card-header collapsed px-1"
                  data-toggle="collapse"
                  data-parent="#accordion"
                  href="#collapseSeventeen"
                >
                  <a class="card-title"> Tags </a>
                </div>
                <div id="collapseSeventeen" class="card-body collapse show">
                  <div class="form-group mb-3">
                    <multiselect
                      v-model="searchObj.skill_ids"
                      :options="skill_list"
                      :multiple="true"
                      placeholder="Select"
                      label="name"
                      track-by="name"
                      value-prop="id"
                      searchable="true"
                      mode="tags"
                      @search-change="searchSkillName($event)"
                      @input="onSkillChange"
                      :show-labels="true"
                    >
                    </multiselect>
                  </div>
                </div>
                <!-- Location -->
                <div
                  class="card-header collapsed px-1"
                  data-toggle="collapse"
                  data-parent="#accordion"
                  href="#collapseEleven"
                >
                  <a class="card-title"> Location </a>
                </div>
                <div id="collapseEleven" class="card-body collapse show">
                  <div class="form-group mb-3">
                    <!-- <label class="mb-1" style="font-weight: normal">Search Location</label> -->
                    <!-- <div class="tags-container">
                    <input data-role='tags-input' placeholder="Search Location" data-placeholder="Search Location"
                      value="" />
                  </div> -->
                    <multiselect
                      v-model="searchObj.country_ids"
                      :options="countryList"
                      :multiple="true"
                      placeholder="Select"
                      label="country_name"
                      track-by="country_name"
                      value-prop="id"
                      searchable="true"
                      mode="tags"
                      @input="onLocationChange"
                      @search-change="searchCountryName($event)"
                      :show-labels="false"
                    >
                    </multiselect>
                  </div>
                </div>
                <!-- Region -->
                <div
                  class="card-header collapsed px-1"
                  data-toggle="collapse"
                  data-parent="#accordion"
                  href="#collapseTen"
                >
                  <a class="card-title"> Region </a>
                </div>
                <div
                  id="collapseTen"
                  class="card-body collapse show"
                  data-parent="#accordion"
                >
                  <form>
                    <div class="d-flex flex-wrap gap-2">
                      <label
                        v-for="(region, index) in regionList"
                        :key="index"
                        class="btns btn-block"
                        :class="{
                          'btn-danger': searchObj.region_ids.includes(
                            region.id
                          ),
                          'btn-success active': !searchObj.region_ids.includes(
                            region.id
                          ),
                        }"
                      >
                        <input
                          type="checkbox"
                          class="d-none"
                          :name="region.region_name"
                          :value="region.id"
                          v-model="searchObj.region_ids"
                          autocomplete="off"
                          @change="
                            handleToggle(
                              region.id,
                              'region_new',
                              region.region_name
                            )
                          "
                        />
                        {{ region.region_name }}
                      </label>
                    </div>
                  </form>
                </div>
                <!-- From date --->
                <div
                  class="card-header collapsed px-1"
                  data-toggle="collapse"
                  data-parent="#accordion"
                  href="#collapseSeven"
                >
                  <a class="card-title"> From Date </a>
                </div>
                <div id="collapseSeven" class="card-body collapse show">
                  <div class="form-group mb-3">
                    <!-- <label class="mb-1" style="font-weight: normal">Select From Date</label> -->
                    <datepicker
                      v-model="searchObj.from_date"
                      inputFormat="dd/MM/yyyy"
                      placeholder="Select"
                      class="form-control"
                      style="background-color: white !important; height: 35px"
                      :clearable="false"
                      :upperLimit="
                        searchObj.to_date ? searchObj.to_date : new Date()
                      "
                      @click="onClickFromDate()"
                    >
                    </datepicker>
                  </div>
                </div>
                <!---- To date --->
                <div
                  class="card-header collapsed px-1"
                  data-toggle="collapse"
                  data-parent="#accordion"
                  href="#collapseEight"
                >
                  <a class="card-title"> To Date </a>
                </div>
                <div id="collapseEight" class="card-body collapse show">
                  <div class="form-group mb-3">
                    <!-- <label class="mb-1" style="font-weight: normal">Select To Date</label> -->
                    <datepicker
                      v-model="searchObj.to_date"
                      inputFormat="dd/MM/yyyy"
                      class="form-control"
                      placeholder="Select"
                      :clearable="false"
                      style="
                        background-color: white !important;
                        z-index: 3000 !important;
                      "
                      :lowerLimit="
                        searchObj.from_date ? searchObj.from_date : null
                      "
                      :upperLimit="new Date()"
                      @click="onClickFromDate()"
                    >
                    </datepicker>
                  </div>
                </div>
                <!---- Date period --->
                <div
                  class="card-header collapsed px-1"
                  data-toggle="collapse"
                  data-parent="#accordion"
                  href="#collapseNine"
                >
                  <a class="card-title"> Date period </a>
                </div>
                <div id="collapseNine" class="card-body collapse show">
                  <div class="form-group mb-3" style="margin-bottom: 10rem !important">
                    <!-- <label class="mb-1" style="font-weight: normal">Select Date Period</label> -->
                    <Multiselect
                      mode="single"
                      trackBy="value"
                      label="value"
                      valueProp="id"
                      v-model="searchObj.date_period"
                      :options="date_periods"
                      searchable="true"
                      placeholder="Select"
                      @change="dateFilter($event)"
                      @click="onClickDatePeriod()"
                    />
                  </div>
                </div>
                <!-- ADD NEW FROM HERE  -->
              </div>
            </div>
          </div>
          <hr />
          <div
            class="d-flex justify-content-between align-items-center px-3 posfixed"
          >
            <button
              v-on:click="
                getList(0);
                openCloseModel();
              "
              class="apply-btn mr-2"
            >
              Apply
            </button>
            <button
              v-on:click="
                resetFilter();
                openCloseModel();
              "
              type="button"
              class="apply-btn"
            >
              Reset
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ErrorComponent from "@/components/ErrorComponent";
import Pagination from "@/components/Pagination";
import CountryFlag from "vue-country-flag-next";
import datepicker from "vue3-datepicker";
import Multiselect from "@vueform/multiselect";
import moment from "moment";
// import moment from "moment";
export default {
  name: "Commentaries",
  components: {
    ErrorComponent,
    Pagination,
    datepicker,
    Multiselect,
    CountryFlag,
  },
  data() {
    return {
      id: this.$route.params.id,
      loader: true,
      isShowSubsector: false,
      showAllIndustries: false,
      showDidYouMean: false,
      searchedPrompt: "",      
      region_obj: {},
      country_obj: {},
      count: 0,
      offset: -1,
      list: [],
      companyList: [],
      industryList: [],
      dealStageList: [],
      dealStageKeyword: "",
      topicList: [],
      countryList: [],
      company_ids: [],
      subsectorList: [],
      regionList: [],
      regionKeyword: "",
      subsectorKeyword: "",
      companyKeyword: "",
      topicKeyword: "",
      company_types: [
        "Public",
        "Private",
        "Education",
        "Government",
        "Not-for-Profit",
        "Venture Funded",
        "PE Backed",
      ],
      date_periods: [
        "Last Month",
        "Last 3 Month",
        "Last 6 Month",
        "Last 1 Year",
      ],
      searchObj: {
        type: "",
        from_date: "",
        to_date: "",
        industry_ids: [],
        company_ids: [],
        keyword: "",
        topic_ids: [],  // also know as deal_type
        deal_stage_ids: [],
        subsector_ids: [],
        country_ids: [],
        company_types: [],
        region_ids: [],
        date_period: "",
        skill_ids: [],  // tags (company skills)
      },
      skill_list: [],
      skillKeyword: "",
      countryKeyword: "",
      selectedFilters: [],
      isOpenModel: false,
    };
  },
  mounted() {
    if (this.id) {
      this.searchObj.company_ids.push(this.id);
      this.selectedFilters.push({
        id: this.id,
        name: '',
        type: "company",
      });
      this.company_ids.push(this.id);
    }
    this.globelSearchResult();
    this.topiclist();
    this.getList(0);
    this.industrylist();
    this.getDealStageList();
    this.getRegionlist();
    this.getCountryList();
    this.companylist();
    this.getskillList();
  },
   watch: {
    'searchObj.industry_ids'(newVal) {

      if (newVal.length === 1) {
        const selectedIndustryId = newVal[0];
        this.onIndustryChange(selectedIndustryId);
        
      } else {
        this.subsectorList = [];
        this.isShowSubsector = false;
        this.searchObj.subsector_ids = [];
        this.selectedFilters = this.selectedFilters.filter(
        (f) => !(f.type === 'subsector')
      );
      }
    },

    // Scroll hide when Offcanvas open
    isOpenModel(newVal) {
    if (newVal) {
      document.body.classList.add('no-scroll');
    } else {
      document.body.classList.remove('no-scroll');
    }
  }

  },
  methods: {
    resetFilter() {
      // this.searchObj = {};
      this.searchObj.type = "";
      this.searchObj.keyword = "";
      this.searchObj.from_date = "";
      this.searchObj.to_date = "";
      this.searchObj.industry_ids = [];
      this.searchObj.job_function_ids_new = [];
      this.searchObj.topic_ids = [];
      this.searchObj.country_ids = [];
      this.searchObj.company_types = [];
      this.searchObj.deal_stage_ids = [];
      this.searchObj.subsector_ids = [];
      this.searchObj.region_ids = [];
      this.searchObj.date_period = "";
      this.searchObj.skill_ids = [];
      this.isShowSubsector = false;
      if (!this.id) {
        this.searchObj.company_ids = [];
      }
      this.selectedFilters = [];
      this.showDidYouMean = false;
      this.getList(0);
    },
    getDisplayedIndustries() {
      return this.showAllIndustries ? this.industryList : this.industryList.slice(0, 15);
    },
    handleShowMore() {
      this.showAllIndustries = true;
    },
    openCloseModel() {
      this.isOpenModel = !this.isOpenModel;
    },
    removeSelectedFilter(filter) {
      if (filter.type === "job_function") {
        this.searchObj.job_function_ids_new =
          this.searchObj.job_function_ids_new.filter((id) => id !== filter.id);
      } else if (filter.type === "deal_type") {
        this.searchObj.topic_ids = this.searchObj.topic_ids.filter( // deal type is also know as topic
          (id) => id !== filter.id
        );
      } else if (filter.type === "industry") {
        this.searchObj.industry_ids = this.searchObj.industry_ids.filter(
          (id) => id !== filter.id
        );
      } else if (filter.type === "education") {
        this.searchObj.education_ids = this.searchObj.education_ids.filter(
          (id) => id !== filter.id
        );
      } else if (filter.type === "age_range") {
        this.searchObj.age_range_ids = this.searchObj.age_range_ids.filter(
          (id) => id !== filter.id
        );
      } else if (filter.type === "seniority") {
        this.searchObj.seniority_ids = this.searchObj.seniority_ids.filter(
          (id) => id !== filter.id
        );
      } else if (filter.type === "region_new") {
        this.searchObj.region_ids = this.searchObj.region_ids.filter(
          (id) => id !== filter.id
        );
      } else if (filter.type === "company_type") {
        this.searchObj.company_types = this.searchObj.company_types.filter(
          (id) => id !== filter.id
        );
      } else if (filter.type === "deal_stage") {
        this.searchObj.deal_stage_ids = this.searchObj.deal_stage_ids.filter(
          (id) => id !== filter.id
        );
      } else if (filter.type === "company") {
        this.searchObj.company_ids = this.searchObj.company_ids.filter(
          (id) => id !== filter.id
        );
      } else if (filter.type === "location") {
        this.searchObj.country_ids = this.searchObj.country_ids.filter(
          (id) => id !== filter.id
        );
      } else if (filter.type === "subsector") {
        this.searchObj.subsector_ids = this.searchObj.subsector_ids.filter(
          (id) => id !== filter.id
        );
      } else if (filter.type === "skill") {
        this.searchObj.skill_ids = this.searchObj.skill_ids.filter(
          (id) => id !== filter.id
        );
      }

      // Later you can handle other types like 'company' etc.

      // This line ensures it's removed visually too
      this.selectedFilters = this.selectedFilters.filter(
        (f) => !(f.id === filter.id && f.type === filter.type)
      );
    },
    onCompanyChange(selectedIds) {
      this.selectedFilters = this.selectedFilters.filter(
        (filter) => filter.type !== "company" || selectedIds.includes(filter.id)
      );

      // Add any new ones
      selectedIds.forEach((id) => {
        const exists = this.selectedFilters.some(
          (f) => f.id === id && f.type === "company"
        );
        if (!exists) {
          const company = this.companyList.find((c) => c.id === id);
          if (company) {
            this.selectedFilters.push({
              id: company.id,
              name: company.company_name,
              type: "company",
            });
          }
        }
      });
    },
    onLocationChange(selectedIds) {
      this.selectedFilters = this.selectedFilters.filter(
        (filter) =>
          filter.type !== "location" || selectedIds.includes(filter.id)
      );

      // Add any new ones
      selectedIds.forEach((id) => {
        const exists = this.selectedFilters.some(
          (f) => f.id === id && f.type === "location"
        );
        if (!exists) {
          const country = this.countryList.find((c) => c.id === id);
          if (country) {
            this.selectedFilters.push({
              id: country.id,
              name: country.country_name,
              type: "location",
            });
          }
        }
      });
    },
    onSkillChange(selectedIds) {
      this.selectedFilters = this.selectedFilters.filter(
        (filter) => filter.type !== "skill" || selectedIds.includes(filter.id)
      );

      // Add any new ones
      selectedIds.forEach((id) => {
        const exists = this.selectedFilters.some(
          (f) => f.id === id && f.type === "skill"
        );
        if (!exists) {
          const skill = this.skill_list.find((c) => c.id === id);
          if (skill) {
            this.selectedFilters.push({
              id: skill.id,
              name: skill.name,
              type: "skill",
            });
          }
        }
      });
    },
    searchSkillName(e) {
      if (e) {
        this.skillKeyword = e;
        this.getskillList();
      }
    },
    getskillList() {
      var obj = {};
      if (this.skillKeyword) {
        obj.keyword = this.skillKeyword;
      }
      this.$api
        .getAPI({
          _action: "/skills/list",
          _body: obj,
        })
        .then((res) => {
          this.skill_list = res;
          // keep picked skills that fall outside this page of results, so their
          // tags still show a name
          this.selectedFilters
            .filter((f) => f.type === "skill" && !res.some((s) => s.id === f.id))
            .forEach((f) => this.skill_list.push({ id: f.id, name: f.name }));
        })
        .catch(() => {});
    },
    handleToggle(id, type, name) {
      const exists = this.selectedFilters.find(
        (item) => item.id === id && item.type === type
      );

      if (!exists) {
        this.selectedFilters.push({
          id: id,
          name: name,
          type: type,
        });
      } else {
        this.selectedFilters = this.selectedFilters.filter(
          (item) => !(item.id === id && item.type === type)
        );
      }
    },

    searchTopicName(e) {
      this.topicKeyword = e;
      this.topiclist();
    },
    geteComponydetail(id) {
      if (id) {
        this.$api
          .getAPI({
            _action: "/company/detail/" + id,
          })

          .then((res) => {
            this.searchObj.industry_id = res.industry_id;
          })
          .catch(() => {});
      }
    },
    onIndustryChange(selectedIndustryId) {
      if (selectedIndustryId) {
        this.subsectorList = [];
        this.isShowSubsector = false;
        this.getSubsectorList(selectedIndustryId);
      } else {
        this.isShowSubsector = false;
      }
    },
    closesub(e) {
      if (!e) {
        this.searchObj.subsector_ids = [];
      }
    },
    searchIndustryName(e) {
      this.industryKeyword = e;
      this.industrylist();
    },
    industrylist() {
      this.$api
        .getAPI({
          _action: "/industry/list",
        })
        .then((res) => {
          this.industryList = res;
          if (this.selectedFilters && this.selectedFilters.length > 0) {
            for (var i in this.selectedFilters) {
              for (var j in res) {
                if (
                  res[j].id == this.selectedFilters[i].id &&
                  this.selectedFilters[i].type == "industry"
                ) {
                  this.selectedFilters[i].name = res[j].industry_name;
                }
              }
            }
          }          
        })
        .catch(() => {});
    },
    getSubsectorList(id) {
      this.$api
        .getAPI({
          _action: "/subsectors/list/" + id,
        })
        .then((res) => {
          res = res.list;
          this.subsectorList = res;

          // Only show subsector dropdown if there are subsectors(of industry) available
          if (this.subsectorList.length > 0) {
            this.isShowSubsector = true;
          } else {
            this.isShowSubsector = false;
          }

          if (this.selectedFilters && this.selectedFilters.length > 0) {
            for (var i in this.selectedFilters) {
              for (var j in res) {
                if (
                  res[j].id == this.selectedFilters[i].id &&
                  this.selectedFilters[i].type == "subsector"
                ) {
                  this.selectedFilters[i].name = res[j].industry_name;
                }
              }
            }
          }
        })
        .catch(() => {
          this.isShowSubsector = false;
        });
    },
    searchDealStage(e) {
      this.dealStageKeyword = e;
      this.getDealStageList();
    },
    getDealStageList() {
      this.$api
        .getAPI({
          _action: "/deal/stage/list",
        })
        .then((res) => {
          this.dealStageList = res;
          if (this.selectedFilters && this.selectedFilters.length > 0) {
            for (var i in this.selectedFilters) {
              for (var j in res) {
                if (
                  res[j].id == this.selectedFilters[i].id &&
                  this.selectedFilters[i].type == "deal_stage"
                ) {
                  this.selectedFilters[i].name = res[j].name;
                }
              }
            }
          }                    
        })
        .catch(() => {});
    },
    locationInput(e) {
      if (e) {
        const selectedLocation = this.countryList.find(
          (country) => country.id == e
        );
        if (selectedLocation) {
          this.region_obj.regionid = selectedLocation.region_id;
          this.getRegionlist();
        }
      } else {
        this.region_obj.regionid = "";
        this.getRegionlist();
      }
    },
    searchCountryName(e) {
      this.countryKeyword = e;
      this.getCountryList();
    },
    getCountryList() {
      // var obj = {};
      if (this.countryKeyword) {
        this.country_obj.keyword = this.countryKeyword;
      }
      this.$api
        .getAPI({
          _action: "/country/list",
          _body: this.country_obj,
        })
        .then((res) => {
          if (this.countryKeyword || this.searchObj.country_ids?.length > 0) {
            this.countryList = res;
            if (this.selectedFilters && this.selectedFilters.length > 0) {
              for (var i in this.selectedFilters) {
                for (var j in res) {
                  if (
                    res[j].id == this.selectedFilters[i].id &&
                    this.selectedFilters[i].type == "location"
                  ) {
                    this.selectedFilters[i].name = res[j].country_name;
                  }
                }
              }
            }
          } else {
            // this.countryList = [];
          }
        })
        .catch(() => {});
    },
    regionInput(e) {
      if (e) {
        this.country_obj.regionid = e;
        this.getCountryList();
      } else {
        this.country_obj.regionid = "";
        this.getCountryList();
      }
    },
    searchRegionName(e) {
      this.regionKeyword = e;
      this.getRegionlist();
    },
    getRegionlist() {
      // var obj = {};
      if (this.regionKeyword) {
        this.region_obj.keyword = this.regionKeyword;
      }
      this.$api
        .getAPI({
          _action: "/region/list",
          _body: this.region_obj,
        })
        .then((res) => {
          this.regionList = res;
          if (this.selectedFilters && this.selectedFilters.length > 0) {
            for (var i in this.selectedFilters) {
              for (var j in res) {
                if (
                  res[j].id == this.selectedFilters[i].id &&
                  this.selectedFilters[i].type == "region_new"
                ) {
                  this.selectedFilters[i].name = res[j].region_name;
                }
              }
            }
          }
        })
        .catch(() => {});
    },
    globelSearchResult() {
      let filters = this.$shareService.getMapValueAndRemove("global_search_filter");      
      if (filters && Object.keys(filters).length > 0) { 

        // Did you mean
        this.showDidYouMean = filters.flag;
        this.searchedPrompt = filters.prompt;

        let current_companyid =
          filters.coid && filters.coid != 0 ? Number(filters.coid) : "";  // current company
        if (current_companyid) {
          this.searchObj.company_ids.push(current_companyid);
          this.company_ids.push(current_companyid);
          this.selectedFilters.push({
            id: current_companyid,
            name: "",
            type: "company",
          });
        }

        let industryId =
          filters.iid && filters.iid != 0 ? Number(filters.iid) : ""; // Industry         
        if (industryId) {
          this.searchObj.industry_ids.push(industryId);
          this.selectedFilters.push({
            id: industryId,
            name: "",
            type: "industry",
          });

            let subsectorid =
              filters.ssid && filters.ssid != 0 ? Number(filters.ssid) : "";   // Subsector
            if (subsectorid) {
              this.searchObj.subsector_ids.push(subsectorid);
              this.selectedFilters.push({
                id: subsectorid,
                name: "",
                type: "subsector",
              });  
            }
            this.getSubsectorList(industryId);
        }

        let topicid =
          filters.tid && filters.tid != 0 ? Number(filters.tid) : ""; // deal type (also know as topic)
        if (topicid) {
          this.searchObj.topic_ids.push(topicid);
          this.selectedFilters.push({
            id: topicid,
            name: "",
            type: "deal_type",
          });
        }

        let stageId =
          filters.sid && filters.sid != 0 ? Number(filters.sid) : ""; // deal stage
        if (stageId) {
          this.searchObj.deal_stage_ids.push(stageId);
          this.selectedFilters.push({
            id: stageId,
            name: "",
            type: "deal_stage",
          });
        }

        let companyType = filters.ctype ?? "";  // company type
        if (companyType) {
          this.searchObj.company_types.push(
            this.$helperService.getCompanyTypeLabel(companyType)
          );
          this.selectedFilters.push({
            id: this.$helperService.getCompanyTypeLabel(companyType),
            name: this.$helperService.getCompanyTypeLabel(companyType),
            type: "company_type",
          });
        }

        let countryId =
          filters.cid && filters.cid != 0 ? Number(filters.cid) : ""; // Location(country)
        if (countryId) {
          this.searchObj.country_ids.push(countryId);
          this.country_obj.keyword = "";
          this.selectedFilters.push({
            id: countryId,
            name: "",
            type: "location",
          });
        }

        let current_regionid =
          filters.rid && filters.rid != 0 ? Number(filters.rid) : "";  // current region
        if (current_regionid) {
          this.searchObj.region_ids.push(current_regionid);
          this.selectedFilters.push({
            id: current_regionid,
            name: "",
            type: "region_new",
          });
        }

        // dashboard sentence search: tags (company skills), and the picked
        // names so the chips read right away
        (filters.skills || []).forEach((skill) => {
          this.searchObj.skill_ids.push(skill.id);
          this.selectedFilters.push({ id: skill.id, name: skill.name, type: "skill" });
        });
        if (filters.labels) {
          this.selectedFilters.forEach((filter) => {
            if (!filter.name && filters.labels[filter.type]) {
              filter.name = filters.labels[filter.type];
            }
          });
        }
      }
    },
    topiclist() {
      var obj = {};
      if (this.topicKeyword) {
        obj.keyword = this.topicKeyword;
      }
      this.$api
        .getAPI({
          _action: "/deals-type/list",
          _body: obj,
        })
        .then((res) => {
          this.topicList = res;
          if (this.selectedFilters && this.selectedFilters.length > 0) {
            for (var i in this.selectedFilters) {
              for (var j in res) {
                if (
                  res[j].id == this.selectedFilters[i].id &&
                  this.selectedFilters[i].type == "deal_type"
                ) {
                  this.selectedFilters[i].name = res[j].topic_name;
                }
              }
            }
          }          
        })
        .catch(() => {});
    },
    searchCompanyName(e) {
      this.companyKeyword = e;
      this.companylist();
    },
    companylist() {
      var obj = {};
      if (this.companyKeyword) {
        obj.keyword = this.companyKeyword;
      }
      if (this.company_ids) {
        obj.company_ids = this.company_ids;
      }

      var selectedCompanies = this.selectedFilters
        .filter((filter) => filter.type == "company")
        .map((filter) => filter.id);

      if (selectedCompanies) {
        obj.company_ids = selectedCompanies;
      }

      this.$api
        .getAPI({
          _action: "/company/list",
          _body: obj,
        })
        .then((res) => {
          if (this.companyKeyword || this.company_ids?.length > 0) {
            this.companyList = res;
            if (this.selectedFilters && this.selectedFilters.length > 0) {
              for (var i in this.selectedFilters) {
                for (var j in res) {
                  if (
                    res[j].id == this.selectedFilters[i].id &&
                    this.selectedFilters[i].type == "company"
                  ) {
                    this.selectedFilters[i].name = res[j].company_name;
                  }
                }
              }
            }
          } else {
            // this.companyList = [];
          }
        })
        .catch(() => {});
    },
    openLink(url) {
      window.open(url);
    },
    pageChange(offset) {
      this.getList(offset - 1);
    },
    itemsPerPageChange() {
      this.itemsPerPage = this.$refs.listPagination.itemsPerPage;
      this.getList(0);
    },
    onClickFromDate() {
      this.searchObj.date_period = "";
    },
    dateFilter(e) {
      if (!e) {
        this.searchObj.date_period = "";
      }
    },
    onClickDatePeriod() {
      this.searchObj.from_date = "";
      this.searchObj.to_date = "";
    },
    getList(page) {
      this.$refs.errorComponent.updateListLoader(true);
      this.list = [];
      this.searchObj.offset = page;
      var obj = {};
      obj.offset = this.searchObj.offset;
      if (this.searchObj.from_date) {
        obj.from_date = moment(this.searchObj.from_date).format("DD-MM-YYYY");
      }
      if (this.searchObj.to_date) {
        obj.to_date = moment(this.searchObj.to_date).format("DD-MM-YYYY");
      }
      if (this.searchObj.date_period) {
        obj.date_period = this.searchObj.date_period;
      }
      if (this.searchObj.topic_ids) {
        obj.topic_id = this.searchObj.topic_ids;
      }

      if (this.searchObj.company_ids) {
        obj.company_id = this.searchObj.company_ids;
      }
      if (this.searchObj.industry_ids) {
        obj.industry_id = this.searchObj.industry_ids;
      }
      if (this.searchObj.deal_stage_ids) {
        obj.deal_stage_id = this.searchObj.deal_stage_ids;
      }
      if (this.searchObj.subsector_ids) {
        obj.subsector_id = this.searchObj.subsector_ids;
      }
      if (this.searchObj.keyword) {
        obj.keyword = this.searchObj.keyword;
      }
      if (this.searchObj.country_ids) {
        obj.country_id = this.searchObj.country_ids;
      }
      if (this.searchObj.company_types) {
        obj.company_type = this.searchObj.company_types;
      }
      if (this.searchObj.region_ids) {
        obj.region_id = this.searchObj.region_ids;
      }
      if (this.searchObj.skill_ids) {
        obj.skill_id = this.searchObj.skill_ids;
      }
      this.$api
        .getAPI({
          _action: "/deals/pagination/list",
          _body: obj,
        })
        .then((res) => {
          this.loader = false;
          this.list = res.list;
          this.offset = res.next_offset;
          this.count = res.count;
          if (page == 0) {
            if (this.$refs.listPagination) {
              if (res.count != null && res.count > 0) {
                this.$refs.listPagination.setTotalCount(res.count);
              } else {
                this.$refs.listPagination.setTotalCount(0);
              }
            }
          }
          if (this.$refs.errorComponent) {
            this.$refs.errorComponent.setData(
              res,
              "No Deals and Transactions list available"
            );
            this.$refs.errorComponent.updateListLoader(false);
          }
        })
        .catch(() => {
          this.loader = false;
          if (this.$refs.errorComponent) {
            this.$refs.errorComponent.setData(0, undefined, "");
            this.$refs.errorComponent.updateListLoader(false);
          }
        });
    },
  },
};
</script>
<style src="@vueform/multiselect/themes/default.css"></style>
<style scoped>
/* ---- Deal card tags ---- */
.news-tags {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  text-align: left;
  margin-top: 10px;
}

.news-tags-label {
  flex: 0 0 auto;
  margin-right: 8px;
  font-size: 10px;
  font-style: italic;
  color: #98a2b3;
}

.news-tag {
  display: inline-block;
  margin: 2px 4px 2px 0;
  padding: 1px 7px;
  border: 1px solid transparent;
  border-radius: 4px;
  font-size: 10.5px;
  line-height: 1.5;
  white-space: nowrap;
}

/* same tint the news page uses for company tags */
.news-tag-company {
  background: #eef2ff;
  border-color: #e0e5ff;
  color: #4338ca;
}

.multiselect {
  background: #f0f0f0;
  height: 35px;
  border: 1px solid;
}

.multiselect-tag {
  background: #9cc338 !important;
}
[data-toggle="buttons"] > .btns input[type="checkbox"],
[data-toggle="buttons"] > .btn-group > .btns input[type="checkbox"] {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}
[type="radio"]:checked,
[type="radio"]:not(:checked) {
  position: relative !important;
  left: 0 !important;
}
label.btns.btn-block.btn-success.active,
label.btns.btn-block.btn-danger {
  border-radius: 15px;
  font-size: 11px;
  color: black;
  margin: 2px;
  padding: 4px 12px;
  font-weight: normal;
  cursor: pointer;
}
label.btns.btn-block.btn-success.active {
  background-color: #e2f0d9;
}
label.btns.btn-block.btn-danger {
  background: #d2ecff;
}
.btn-block {
  display: inline-block;
  width: auto;
}
.card .card-body {
  padding: 2px;
  margin: 0;
}
.input-tags {
  width: 100%;
  padding: 15px;
  display: block;
  margin: 0 auto;
}
.tags-container .tag {
  position: relative;
  padding-right: 24px;
  padding-top: 0.4em;
  padding-bottom: 0.4em;
  padding-left: 0.4em;
  font-size: 85%;
  margin-left: 0.25rem;
}
.card-title {
  font-size: 13px;
}

.selected-chip {
  background-color: #d2ecff; /* light green */
  border-radius: 15px;
  font-size: 12px;
  color: black;
  margin: 2px;
  padding: 10px 20px;
  font-weight: normal;
  cursor: pointer;
}

.remove-icon {
  margin-left: 8px;
  cursor: pointer;
  font-weight: bold;
}
</style>
